import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import ContentHeader from 'component/utils/ContentHeader'
import Rupture from 'component/report/rupture/Rupture'

class RuptureContainer extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
  }

  render() {
    const { translate } = this.props

    return (
      <section>
        <ContentHeader>{translate('ruptures.title')}</ContentHeader>

        <Rupture translate={translate} />
      </section>
    )
  }
}

/*
 * Connects component to I18next
 */
const RuptureTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(RuptureContainer)

/*
 * Exports component connected to redux as default
 */
export default RuptureTranslated

/*
 * Exports as component
 */
export { RuptureContainer }